import { createLoader } from '../../loader';
import { fetchSharing, saveSharing } from '../../actions/content';
import { getSharingStudents } from '../../selectors/content';
import Loader from '../loader.jsx';
import connect from '../connect';
import { sharingResource } from '../../resources/sharing';
import Sharing from './sharing.ui.jsx';
import { routeToContentPage } from '../../actions/route';

function mapStateToProps(state, ownProps) {
    return { rootState: state };
}

const LoaderView = createLoader({
    busy: Loader,
    component: Sharing,
    resources: {
        settings(options) {
            const { id } = options.props.content;
            return sharingResource(options, id);
        },
        students: {
            depends: ['settings'],
            students(options, settings) {
                return () =>
                    getSharingStudents(options.rootState, options.props.content)
                        .learners;
            },
        },
    },
});

export default connect(
    mapStateToProps,
    {
        routeToContentPage,
        fetchSharing,
        saveSharing,
    },
    null,
    { pure: true }
)(LoaderView);



// WEBPACK FOOTER //
// ./src/components/engage_reader/sharing.jsx